/*
 * Wizard extras action types
 */

export const CREATE_EXTRA = 'CREATE_EXTRA';
export const TOGGLE_EXTRA = 'TOGGLE_EXTRA';

export const createExtra = (id, extraType, name, label, labelType, amount, description, readMoreLink, active) => ({
    type: CREATE_EXTRA,
    id,
    extraType,
    name,
    label,
    labelType,
    amount,
    description,
    readMoreLink,
    active,
});

export const toggleExtra = (extraType, active) => ({
    type: TOGGLE_EXTRA,
    extraType,
    active,
});